import VueRouter from 'vue-router'
import Index from '@/pages/index'
import CarefullyChosen from '@/pages/carefullyChosen'
import Person from '@/pages/person/index.vue'
import ExchangeIndex from '@/pages/contentPage/exchange/index.vue'
import ExchangeSucess from '@/pages/contentPage/exchange/succes.vue'
import Ceshi from '@/pages/ceshi.vue'
import MyOrders from '@/pages/person/myOrders.vue'
import OrderDetail from '@/pages/person/orderDetail.vue'

import store from '@/store'
import {apiOpenid} from '@api'

const routes = [
    {
        path:'/',
        component:Index,
        name:'index',
    },
    {
        path:'/CarefullyChosen',
        component:CarefullyChosen,
        name:'CarefullyChosen'
    },
    {
        path:'/Person',
        component:Person,
        name:'Person'
    },
    {
        path:'/ExchangeIndex',
        component:ExchangeIndex,
        name:'ExchangeIndex'
    },
    {
        path:'/ExchangeSucess',
        component:ExchangeSucess,
        name:'ExchangeSucess'
    },
    {
        path:'/MyOrders',
        component:MyOrders,
        name:'MyOrders'
    },
    {
        path:'/OrderDetail',
        component:OrderDetail,
        name:'OrderDetail'
    },
    {
        path:'/Ceshi',
        component:Ceshi,
        name:'Ceshi'
    },
    
]

const router = new VueRouter({
    mode:'hash',
    routes ,// (缩写) 相当于 routes: routes
   
    base:'/'
    
  })

let Tabars=['index','CarefullyChosen','Person']

router.beforeEach(async (to, from, next) => {
    console.log(to)

    //如果是从兑换成功页跳返回到提交地址也
    if(from.name == "ExchangeSucess" &&to.name=="ExchangeIndex"){
        router.go(-1)
        
    }
    var search = window.location.search
    var openid =window.localStorage.getItem("openid")
    let code = ""
    if(search){
        console.log(search)
        let params = search.split("?")[1]
        let params1 = params.split("&")[0]
        code=params1.split("=")[1]
         if(code){
            store.commit('storeCode',{
                code:code
            })
        }
    }
    if(store.state.code && !openid){
        await getOpenid()
        next()
        return
     }
    // window.localStorage.setItem("openid",'oPsZDtyhwUhN7dfYdwoeGVIQEbbc');
    // next()
    // ${to.fullPath}
    if(!openid){
        var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxc808b8f84d6f4b07&redirect_uri=https://qianyaolipin.duokakeji.cn${to.fullPath}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
        console.log(url)
        // // return
        window.location.href=url
    }else{
        next()
        // if(base_url){
        //     next({
        //         path:base_url
        //     })
            
        // }else{
        //     next()
        // }
        
    }
   
  
    // 如果用户未能验证身份，则 `next` 会被调用两次
  })

router.afterEach((to,) => {
    if(Tabars.includes(to.name)){
        store.commit('changeHasBar',{
            hasBar:true
        })
    }else{
        store.commit('changeHasBar',{
            hasBar:false
        })
    }
    if(to.name == 'index'){
        store.commit('changeBarFixed', {
            barFixed:false
        })
    }else{
        store.commit('changeBarFixed', {
            barFixed:true
        })
    }
})

async function getOpenid (){
    const [err,data] = await apiOpenid({
        code:store.state.code,
    })
    if(err) return console.warn(err)
    store.commit("storeOpenid",{
        openid:data.openid
    })
    window.localStorage.setItem("openid",data.openid);
   
}

export default router